import {sendRequest} from "./Sender";

export const ArtistService = {
    GetList,
    Create,
    GetById,
    Delete,
    Update
}

function GetList(params= [], expand = ''){
    return sendRequest('artists', 'GET', {...params, 'expand': expand}, true)
}


function GetById(id, expand = ''){
    return sendRequest('artists/'  + id, 'GET', {'expand': expand}, true)
}

function Create(data){
    return sendRequest('artists', 'POST', data, true)
}
function Delete(id){
    return sendRequest('artists/' + id, 'DELETE', {}, true)
}
function Update(id, data){
    return sendRequest('artists/' + id, 'PUT', {...data}, true)
}